"use client";
import React from "react";
import { motion } from "framer-motion";
import { MdOutlineEmail } from "react-icons/md";
import { LuPhone, LuCalendarDays } from "react-icons/lu";
import { GiModernCity } from "react-icons/gi";
import { MdOutlineAttachMoney, MdFamilyRestroom } from "react-icons/md";
import { IoColorPaletteOutline } from "react-icons/io5";

export default function ClientInfoCard({ client }) {
  const infoItems = [
    [
      {
        icon: <MdOutlineEmail />,
        label: "Email",
        value: client.email || "-",
        accent: "border-l-[#5563F6]"
      },
      {
        icon: <LuPhone />,
        label: "Phone Number",
        value: client.phone_number || "-",
        accent: "border-l-[#5563F6]"
      },
      {
        icon: <MdOutlineAttachMoney />,
        label: "TAX ID",
        value: client.tax_id || "-",
        accent: "border-l-[#5563F6]"
      },
      {
        icon: <LuCalendarDays />,
        label: "Corporate",
        value: client.company_name || "-",
        accent: "border-l-[#5563F6]"
      },
    ],
    [
      {
        icon: <GiModernCity />,
        label: "Country",
        value: client.country || "-",
        accent: "border-l-[#5563F6]"
      },
      {
        icon: <MdFamilyRestroom />,
        label: "Family Status",
        value: client.family_status || "-",
        accent: "border-l-[#5563F6]"
      },
      {
        icon: <IoColorPaletteOutline />,
        label: "Hobbies",
        value: client.hobbies || "-",
        accent: "border-l-[#5563F6]"
      },
      {
        icon: <LuCalendarDays />,
        label: "Birthday",
        value: client.birthday || "-",
        accent: "border-l-[#5563F6]"
      },
    ]
  ];

  return (
    <div className="grid md:grid-cols-2 gap-4 w-full">
      {infoItems.map((column, colIndex) => (
        <div key={colIndex} className="space-y-2">
          {column.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.05 + colIndex * 0.1 }}
              whileHover={{ 
                backgroundColor: "rgba(249, 250, 251, 0.8)",
                paddingLeft: "14px"
              }}
              className={`bg-white rounded-lg p-3 border border-gray-100 ${item.accent} border-l-4 transition-all duration-200 hover:shadow-xs`}
            >
              <div className="flex items-center gap-3">
                <div className="text-gray-600">
                  {item.icon}
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-medium text-gray-500">
                      {item.label}
                    </span>
                    <span className="text-sm text-gray-800 font-medium truncate ml-3 max-w-[160px]">
                      {item.value}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      ))}
    </div>
  );
}